// extracted by mini-css-extract-plugin
export default {"contact_us":"ContactUs_contact_us__0NXeq","YourQueryModal_content":"ContactUs_YourQueryModal_content__l7TMv"};